// Build schema.org FAQPage JSON-LD from a list of {q, a} items.
export function faqLd(name, items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name,
    mainEntity: items.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  }
}
